export default {
    methods: {
        postMessageToParent: function (message, params, origin) {
            if (params && params.transactionData) {
                let transactionData = params.transactionData
                if (transactionData.transactionId) message.transactionId = transactionData.transactionId
                if (transactionData.orderId) message.orderId = transactionData.orderId
                if (transactionData.orderRef) message.orderRef = transactionData.orderRef
                if (transactionData.transactionStatusCode) message.transactionStatusCode = transactionData.transactionStatusCode
                if (transactionData.orderStatusCode) message.orderStatusCode = transactionData.orderStatusCode
            }
            window.parent.postMessage(JSON.stringify(message), origin)
        }
    }
}